import { useAuth } from '@/ui/auth/AuthProvider';
import { LogIn, LogOut, User as UserIcon } from 'lucide-react';

export function AuthButton() {
    const { user, signInWithGoogle, signOut } = useAuth();

    if (user) {
        return (
            <div className="flex items-center gap-3">
                <div className="flex items-center gap-2 text-sm text-foreground-muted">
                    {user.photoURL ? (
                        <img
                            src={user.photoURL}
                            alt={user.displayName || 'User'}
                            className="w-6 h-6 rounded-full border border-border"
                        />
                    ) : (
                        <UserIcon className="w-4 h-4" />
                    )}
                    <span className="hidden md:inline">{user.displayName}</span>
                </div>
                <button
                    onClick={signOut}
                    className="btn-ghost p-2 text-foreground-muted hover:text-status-error"
                    title="Sign Out"
                >
                    <LogOut className="w-4 h-4" />
                </button>
            </div>
        );
    }

    return (
        <button
            onClick={signInWithGoogle}
            className="btn-secondary px-3 py-1.5 text-xs flex items-center gap-2"
            title="Sign in with Google"
        >
            <LogIn className="w-3.5 h-3.5" />
            <span>Sign In</span>
        </button>
    );
}
